/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Duration_SecondsInputs */

const en_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in seconds`)
};

const fr_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en secondes`)
};

const de_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in Sekunden`)
};

const it_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in secondi`)
};

const ru_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за секунды`)
};

const es_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en segundos`)
};

const zh_cn2_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只需几秒钟`)
};

const ja_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数秒で`)
};

const hi_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेकंडों में`)
};

const pt_pt2_transcript_export_duration_seconds = /** @type {(inputs: Transcript_Export_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`em segundos`)
};

/**
* | output |
* | --- |
* | "in seconds" |
*
* @param {Transcript_Export_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_seconds = /** @type {((inputs?: Transcript_Export_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_duration_seconds(inputs)
	if (locale === "de") return de_transcript_export_duration_seconds(inputs)
	if (locale === "it") return it_transcript_export_duration_seconds(inputs)
	if (locale === "ru") return ru_transcript_export_duration_seconds(inputs)
	if (locale === "es") return es_transcript_export_duration_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_duration_seconds(inputs)
	if (locale === "ja") return ja_transcript_export_duration_seconds(inputs)
	if (locale === "hi") return hi_transcript_export_duration_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_duration_seconds(inputs)
	return en_transcript_export_duration_seconds(inputs)
});